import { usePromo } from '@entities/promo-video';
import type React from 'react';
import { useNavigate, useParams, useResolvedPath } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import { MenuDropdown } from '@widgets/programs/common/dropdown-menu';
import { MoreHoriz } from '@shared/assets';
import { usePlatformSettings } from '@shared/hooks/index.ts';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { IconButton, useCommonMenu } from '@shared/ui';
import * as st from './styles.module.scss';

type ButtonVariant =
  | 'outlined'
  | 'dark'
  | 'transparent'
  | 'active'
  | 'light'
  | 'secondary'
  | 'mobile'
  | 'white';

type Props = {
  videoId: number;
  variant?: ButtonVariant;
  size?: 'small' | 'medium' | 'medium-large' | 'large';
  editorFormData: any;
};

export const PromoEditorMenu: React.FC<Props> = ({
  videoId,
  variant = 'dark',
  size = 'medium',
  editorFormData,
}) => {
  const { pathname } = useResolvedPath('');
  const navigate = useNavigate();
  const { id } = useParams<{ code: string; id: string }>();
  const { code } = useModuleByCodeParam();
  const { has_library } = usePlatformSettings();
  const { onOpen, onClose, setReferenceEl, referenceEl, popperEl, setPopperEl } = useCommonMenu();

  const { removePromo } = usePromo(videoId);

  const onRemove = () => {
    navigate(
      `/programs/${code}/${has_library ? '' : ''}program-edit/${id}?remove_promo_video=${videoId}`
    );
  };

  const onEdit = () =>
    navigate(`/programs/${code}/${has_library ? '' : ''}program-edit/${id}/promo-edit/${videoId}`);

  return (
    <>
      <IconButton onClick={onOpen} ref={(ref) => setReferenceEl(ref)} variant={variant} size={size}>
        <MoreHoriz />
      </IconButton>
      <MenuDropdown referenceEl={referenceEl} popperEl={popperEl} setPopperEl={setPopperEl}>
        <div className={st.menu}>
          <MenuItem
            onClick={(e) => {
              onClose(e);
              onEdit && onEdit();
            }}
          >
            Изменить
          </MenuItem>

          <MenuItem
            onClick={(e) => {
              onClose(e);
              onRemove && onRemove();
            }}
          >
            Удалить
          </MenuItem>
        </div>
      </MenuDropdown>
    </>
  );
};
